// Cart page add-on recommendation (U38): adds the suggested variant and re-renders the cart sections
// through CartItems, so the summary, progress bar and the next suggestion update without a reload.
if (!customElements.get('furoma-cart-rec')) {
  customElements.define(
    'furoma-cart-rec',
    class FuromaCartRec extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-rec-add]');
          if (!button || button.disabled) return;
          event.preventDefault();
          this.add(button);
        });
      }

      add(button) {
        const cartItems = document.querySelector('cart-items');
        if (!cartItems || typeof cartItems.renderSections !== 'function') return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        const body = JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1, properties: { _rec: button.dataset.rule } }],
          sections: [...new Set(cartItems.getSectionsToRender().map((section) => section.section))],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) throw new Error(state.description || state.message);
            cartItems.renderSections(state.sections);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              cartData: state,
              variantId: button.dataset.variantId,
            });
          })
          .catch(() => {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            const errors = document.getElementById('cart-errors');
            if (errors) errors.textContent = window.cartStrings.error;
          });
      }
    }
  );
}
